export const ERROR_MAP = new Map([
  ['Debit scheduled date and time must be in the future.', 'Funding Leg scheduled date and time must be in the future.'],
  [
    'Credit Leg scheduled date and time must be in the future and after the Funding Leg scheduled date and time.',
    'Disbursement Leg scheduled date and time must be in the future and after the Funding Leg scheduled date and time.',
  ],
  ['Amount or percentage values not present.', 'Enter an amount of percentage.'],
]);
